import {
    AttendeeSurvey,
    isInventoryQuestion,
    SurveyQuestion,
} from '../../models/survey';

export const hasOptionalQuestions = (questions: SurveyQuestion[]) =>
    questions.some((question) => !isRequiredQuestion(question, questions));

export const hasOptionalQuestionsByAttendee = (
    attendeesQuestions: AttendeeSurvey[],
) =>
    attendeesQuestions.some((attendee) =>
        hasOptionalQuestions(attendee.survey),
    );

const hasRequiredChildOrParentOrSibling = ({
    questions,
    currentQuestionName,
    currentQuestionParentName,
}: {
    questions: any[];
    currentQuestionName: string;
    currentQuestionParentName: string | undefined;
}) =>
    questions.some(
        (question) =>
            (question.name === currentQuestionParentName ||
                question.renderConditionTrigger?.parentQuestionId ===
                    currentQuestionName ||
                (currentQuestionParentName
                    ? question.renderConditionTrigger?.parentQuestionId ===
                      currentQuestionParentName
                    : false)) &&
            question.required,
    );

export const isRequiredQuestion = (
    question: SurveyQuestion,
    questions: SurveyQuestion[],
) =>
    question.required ||
    isInventoryQuestion(question.choices) ||
    hasRequiredChildOrParentOrSibling({
        questions,
        currentQuestionName: question.name,
        currentQuestionParentName:
            question.renderConditionTrigger?.parentQuestionId,
    });
